export const validation = {
  code: (value) => {
    if (!value?.trim()) return "Currency code is required";
    return "";
  },
  name: (value) => {
    if (!value?.trim()) return "Currency name is required";
    return "";
  },
  symbol: (value) => {
    if (!value?.trim()) return "Symbol is required";
    return "";
  },
  symbol_position: (value) => {
    if (!value?.trim()) return "Symbol position is required";
    if (!["before", "after"].includes(value)) return "Symbol position must be before or after";
    return "";
  },
  decimal_places: (value) => {
    if (value === undefined || value === "" || value === null) return "";
    if (!Number.isInteger(Number(value)) || Number(value) < 0)
      return "Decimal places must be a non-negative integer";
    return "";
  },
};
